module.exports = __webpack_public_path__ + "img/triangle.11c97349.svg";